package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.CommentType
import com.jingfangpai.common.orm.mapping.enums.CommentEntityType
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.data.serializer.DateTimeSerializer
import com.jingfangpai.common.orm.mapping.enums.CommentStatus

@Serializable
open class Comment(var id: String? = null){
	var parentId: String? = null
	var title: String? = null
	var type: CommentType? = null
	var comment: String? = null
	var description: String? = null
	var entityType: CommentEntityType? = null
	var entityId: String? = null
	var weight: Int? = null
	var thread: String? = null
	@Serializable(with = DateTimeSerializer::class)
	var timestamp: DateTime? = null
	var status: CommentStatus? = null
	var source: String? = null
	var authorId: String? = null
	var createdBy: String? = null
	@Serializable(with = DateTimeSerializer::class)
	var createdOn: DateTime? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as Comment
		if (id != other.id) return false
		if (parentId != other.parentId) return false
		if (title != other.title) return false
		if (type != other.type) return false
		if (comment != other.comment) return false
		if (description != other.description) return false
		if (entityType != other.entityType) return false
		if (entityId != other.entityId) return false
		if (weight != other.weight) return false
		if (thread != other.thread) return false
		if (timestamp != other.timestamp) return false
		if (status != other.status) return false
		if (source != other.source) return false
		if (authorId != other.authorId) return false
		if (createdBy != other.createdBy) return false
		if (createdOn != other.createdOn) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (parentId?.hashCode() ?: 0)
		result = 31 * result + (title?.hashCode() ?: 0)
		result = 31 * result + (type?.hashCode() ?: 0)
		result = 31 * result + (comment?.hashCode() ?: 0)
		result = 31 * result + (description?.hashCode() ?: 0)
		result = 31 * result + (entityType?.hashCode() ?: 0)
		result = 31 * result + (entityId?.hashCode() ?: 0)
		result = 31 * result + (weight?.hashCode() ?: 0)
		result = 31 * result + (thread?.hashCode() ?: 0)
		result = 31 * result + (timestamp?.hashCode() ?: 0)
		result = 31 * result + (status?.hashCode() ?: 0)
		result = 31 * result + (source?.hashCode() ?: 0)
		result = 31 * result + (authorId?.hashCode() ?: 0)
		result = 31 * result + (createdBy?.hashCode() ?: 0)
		result = 31 * result + (createdOn?.hashCode() ?: 0)
		return result
	}

}
